// UAT ENV
// export const apolloURL =
//   "https://pv76vz7a33.execute-api.us-east-2.amazonaws.com/uat/app";
// DEV ENV
// export const apolloURL =
//   "https://owztmzwijh.execute-api.us-east-2.amazonaws.com/dev/app";

// PROD ENV
export const apolloURL =
  "https://api.esignatureguarantee.com/app";
